module.exports = __webpack_public_path__ + "media/images/view-icon-de1dee2e900dfa1b96395c8265ed30ee.svg";